<template>
  <div class="login">
    <div class="login-contain">
      <div>
        <img src="../assets/img/login-logo.png" alt="">
      </div>
      <div class="login-title">文本交叉标注系统</div>
      <div class="login-body">
        <a-form layout="inline" :form="form" @submit="handleSubmit">
          <a-form-item>
            <a-input v-model="username" placeholder="请输入用户名" style="height:40px;width:340px;background-color:transparent;color:#fff">
              <!-- <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" /> -->
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input v-model="password" type="password" placeholder="请输入密码" style="height:40px;width:340px;margin:20px 0;background-color:transparent;color:#fff">
              <!-- <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" /> -->
            </a-input>
          </a-form-item>
          <a-form-item>
              <a-button style="width:340px;height:40px" type="primary" html-type="submit">
                登录
              </a-button>
          </a-form-item>
        </a-form>
        
      </div>
      <div class="login-des">做最专业的机器人电话客服</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  props: {
    msg: String
  },
   data() {
    return {
      form: this.$form.createForm(this, { name: 'horizontal_login' }),
      username: '',
      password: '',
    }
  },
  methods: {
    handleSubmit() {
      this.axios.post('/api/user/login', {
        name: this.username,
        password: this.password
      })
      .then(response=> {
        if(response.data.code == 0){
          this.sessionData('set','token',response.data.data.token);
          this.sessionData('set','role',response.data.data.role);
          if(response.data.data.role == 'MANAGER'){
            this.$router.push("/AdminNav/TaskManage")
          }else if(response.data.data.role == 'MARKER'){
            this.$router.push("/UserNav/MyTask")
          }
        }else{
          this.error(response.data.message)
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    success(msg) {
      this.$message.success(msg);
    },
    error(msg) {
      this.$message.error(msg);
    },
    warning(msg) {
      this.$message.warning(msg);
    },
  },
  mounted: function() {
    this.$nextTick(() => {
      this.form.validateFields();
    });
  }
}
</script>

<style scoped lang="less">
  .login{
    width: 100%;
    height: 100%;
    background: url(../assets/img/bg.jpg);
    position: relative;
    .login-contain{
      width: 460px;
      height: 440px;
      margin: 0 auto;
      display: block;
      position: absolute;
      top: 50%;
      margin-top: -240px;
      left: 50%;
      margin-left: -230px;
      img{
        width: 86px;
      }
      .login-title{
        font-size: 32px;
        color: #fff;
      }
      .login-body{
        width: 100%;
        height: 260px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        font-size: 14px;
        margin-top: 60px;
        padding: 50px 60px;
      }
      .login-des{
        color: rgba(153, 153, 153, 1);
        font-size: 12px;
        margin-top: 24px;
      }
    }
  }
</style>
